"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoMeasurePage = exports.calculateOrientationBearing = exports.PhotoMeasurePageConfig = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_api_2 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const core_shared_2 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const modal_service_1 = require("../components/modal/modal.service");
const theme_1 = require("../components/theme");
const i18n_1 = require("../i18n");
const mithril_1 = require("../mithril");
const collection_view_1 = require("../modules/collection.view/collection.view");
const collection_view_ctrl_1 = require("../modules/collection.view/collection.view.ctrl");
const drawable_properties_1 = require("../modules/collection.view/drawable.properties");
const vertical_separation_field_view_1 = require("../modules/collection.view/fields/vertical.separation.field.view");
const draw_toolbar_1 = require("../modules/draw.toolbar/draw.toolbar");
const hidden_image_icon_1 = require("../modules/hidden.image.icon/hidden.image.icon");
const photomeasure_collection_list_1 = require("../modules/photomeasure.collection.list/photomeasure.collection.list");
const photomeasure_collection_list_style_1 = require("../modules/photomeasure.collection.list/photomeasure.collection.list.style");
const services_1 = require("../services");
const page_state_1 = require("../state/page.state");
const store_1 = require("../store");
const browser_check_1 = require("../util/browser-check");
const classnames_1 = require("../util/classnames");
const missing_page_1 = require("./missing.page");
const page_1 = require("./page");
const pm_events_1 = require("./photomeasure/pm.events");
const tag_state_1 = require("./tag.state");
const CSS = {
    container: 'c-PhotoMeasure',
    center: 'c-PhotoMeasure__center',
    right: 'c-PhotoMeasure__right',
    empty: 'c-PhotoMeasure__empty',
    hiddenCapture: 'c-PhotoMeasure__hiddenCapture',
    drawWrapper: 'c-PhotoMeasure__drawWrapper',
};
const Style = {
    [CSS.container]: {
        height: '100%',
        width: '100%',
        'min-width': '1000px',
        display: 'flex',
        'justify-content': 'space-between',
        [`& .${core_shared_1.SVGRenderer.CSS.svg}`]: {
            outline: `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
        },
        [`& .${photomeasure_collection_list_style_1.CSS.container}`]: {
            width: '25%',
            'min-width': '400px',
        },
    },
    [CSS.center]: {
        position: 'relative',
        display: 'flex',
        flex: 1,
    },
    [CSS.drawWrapper]: {
        position: 'relative',
        flex: 1,
        'text-align': 'center',
    },
    [CSS.right]: {
        position: 'relative',
        display: 'flex',
        width: '25%',
        'min-width': '420px',
    },
    [CSS.empty]: {
        display: 'flex',
        'align-items': 'center',
        'font-size': '250%',
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [CSS.hiddenCapture + '>:not(i)']: {
        filter: 'grayscale(100%) brightness(40%)',
    },
};
(0, theme_1.addStyles)(Style);
(0, theme_1.addStyles)(core_shared_1.ZoomRenderer.Style);
(0, theme_1.addStyles)(core_shared_1.SVGRenderer.Style);
exports.PhotoMeasurePageConfig = {
    type: 'internal',
    name: page_1.IkePageName.collectionMeasure,
    path: '/measure',
    auth: {
        required: true,
    },
    layout: { nav: false },
};
const isVectorOrAnchor = (field) => {
    return core_shared_1.CollectionModelFieldVector.isVectorField(field) || core_shared_1.CollectionModelFieldAnchor.isAnchorField(field);
};
const calculateOrientationBearing = (equipmentOrientation, vector) => {
    const floatValue = (equipmentOrientation === null || equipmentOrientation === void 0 ? void 0 : equipmentOrientation.displayValue) ? parseFloat(equipmentOrientation === null || equipmentOrientation === void 0 ? void 0 : equipmentOrientation.displayValue) : null;
    return floatValue || floatValue === 0
        ? core_shared_1.IkeAngle.toRadians(floatValue)
        : (vector === null || vector === void 0 ? void 0 : vector.value) && typeof vector.value === 'object' && 'bearing' in vector.value
            ? vector.value.bearing
            : null;
};
exports.calculateOrientationBearing = calculateOrientationBearing;
const recursiveSearchParentForVector = (subFormInstance) => {
    let result = null;
    subFormInstance.forEachField((field) => {
        if (isVectorOrAnchor(field)) {
            result = field;
        }
    });
    if (!result && subFormInstance.parent.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
        result = recursiveSearchParentForVector(subFormInstance.parent.parent);
    }
    return result;
};
const recursiveSearchParentForOrientation = (subFormInstance) => {
    let result = null;
    subFormInstance.forEachField((field) => {
        if (field instanceof core_shared_1.CollectionModelFieldNumber &&
            (field.schema.fieldId === 'ipf_equipment:ipf_equipmentOrientation' ||
                field.schema.fieldId === 'equipment:equipmentOrientation')) {
            result = field;
        }
    });
    if (!result && subFormInstance.parent.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
        result = recursiveSearchParentForOrientation(subFormInstance.parent.parent);
    }
    return result;
};
class PhotoMeasurePage extends page_1.IkePage {
    constructor() {
        super(exports.PhotoMeasurePageConfig);
        this.invalidUrl = false;
        this.inspectedVector = null;
        this.inspectedNumber = null;
        this.hoveredVector = null;
        this.hoveredNumber = null;
        this.browserCheck = new browser_check_1.BrowserCheck();
    }
    init() {
        page_state_1.CurrentState.reset();
        this.tagState = new tag_state_1.TagState();
        this.events = new pm_events_1.PhotoMeasureInputEvents(this, this.draw);
        this.events.init();
        this.list = new photomeasure_collection_list_1.PhotomeasureCollectionList(this.tagState);
        this.editControl = new collection_view_ctrl_1.CollectionEditCtrl(this.tagState.map);
        this.editControl.isPhotomeasure = true;
        this.detail = new collection_view_1.CollectionEdit(this.editControl);
        this.eventContext = services_1.Services.Input.getContext();
        this.reaction(() => page_state_1.CurrentState.inspectedCollectionRevision, () => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.updateInspectedCapture();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.updateURL();
        });
        this.reaction(() => {
            const draw = this.draw;
            if (draw == null) {
                return null;
            }
            return draw.state.propertiesId;
        }, (drawableId) => this.viewProperties(drawableId));
        this.reaction(() => page_state_1.CurrentState.hoverId, (hoverId) => {
            if (hoverId && page_state_1.CurrentState.inspectedCollectionRevision) {
                const collection = store_1.AppStore.Collection.get(page_state_1.CurrentState.inspectedCollectionRevision);
                let field = collection === null || collection === void 0 ? void 0 : collection.findField(hoverId);
                if (!field)
                    return;
                if (field instanceof core_shared_1.CollectionModelFieldNumber &&
                    (field.schema.fieldId === 'ipf_equipment:ipf_equipmentOrientation' ||
                        field.schema.fieldId === 'equipment:equipmentOrientation')) {
                    this.setHoveredNumber(field);
                    return;
                }
                else if (field.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
                    const result = recursiveSearchParentForOrientation(field.parent);
                    if (result) {
                        this.setHoveredNumber(result);
                        return;
                    }
                }
                if (isVectorOrAnchor(field)) {
                    this.setHoveredVector(field);
                    return;
                }
                else if (field.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
                    const result = recursiveSearchParentForVector(field.parent);
                    if (result) {
                        this.setHoveredVector(result);
                        return;
                    }
                }
            }
            this.setHoveredVector(null);
            this.setHoveredNumber(null);
        });
        this.reaction(() => page_state_1.CurrentState.inspectedFieldId, (inspectedFieldId) => {
            if (inspectedFieldId && page_state_1.CurrentState.inspectedCollectionRevision) {
                const collection = store_1.AppStore.Collection.get(page_state_1.CurrentState.inspectedCollectionRevision);
                let field = collection.findField(inspectedFieldId);
                if (!field) {
                    this.setInspectedNumber(null);
                    this.setInspectedVector(null);
                    return;
                }
                if (field instanceof core_shared_1.CollectionModelFieldNumber &&
                    (field.schema.fieldId === 'ipf_equipment:ipf_equipmentOrientation' ||
                        field.schema.fieldId === 'equipment:equipmentOrientation')) {
                    this.setInspectedNumber(field);
                    return;
                }
                else if (field.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
                    const result = recursiveSearchParentForOrientation(field.parent);
                    if (result) {
                        this.setInspectedNumber(result);
                        return;
                    }
                }
                // @todo when anchor location types exist, we need to use the geolib
                // to calculate the bearing, as the anchor may not have a vector provider
                // it might be worth removing the isVectorOrAnchor helper when we integrate this.
                if (isVectorOrAnchor(field)) {
                    this.setInspectedVector(field);
                    return;
                }
                else if (field.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
                    const result = recursiveSearchParentForVector(field.parent);
                    if (result) {
                        this.setInspectedVector(result);
                        return;
                    }
                }
            }
            this.setInspectedNumber(null);
            this.setInspectedVector(null);
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.updateInspectedCapture();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.parseURL(services_1.Services.Route.params.toJSON());
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE) ||
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_CTRL_SHIFT_SELECT)) {
            if (this.browserCheck.os === 'Mac OS') {
                // macos
                this.registerCtrlShiftPressed('keydown', true, { meta: true, shift: true });
                this.registerCtrlShiftPressed('keyup', false, { meta: true });
            }
            // windows
            this.registerCtrlShiftPressed('keydown', true, { ctrl: true, shift: true });
            this.registerCtrlShiftPressed('keyup', false, { ctrl: true });
            // common
            this.registerCtrlShiftPressed('keyup', false, { shift: true });
        }
        this.reaction(() => this.draw, () => {
            if (this.draw) {
                this.draw.state.setAutoArrangeAnnotations(this.draw.drawState.hasOnlyInsightDetections());
            }
        });
    }
    get nodes() {
        if (this.invalidUrl) {
            return new missing_page_1.MissingPage().view();
        }
        if (services_1.Services.Department.current == null) {
            return null;
        }
        if (this.tagState == null) {
            this.init();
        }
        return (0, mithril_1.m)('div', { className: CSS.container }, [
            this.list.view(),
            this.viewCenter(),
            (0, mithril_1.m)('div', { className: CSS.right }, [this.detail.view()]),
        ]);
    }
    onRemove() {
        super.onRemove();
        this.tagState.destroy();
        this.events.destroy();
        if (this.editControl) {
            this.editControl.destroy();
        }
    }
    viewCenter() {
        if (this.draw != null) {
            let vector = null;
            let equipmentOrientation = null;
            const hidden = this.draw.state.imageVisibilityHidden;
            if (this.hoveredNumber || this.hoveredVector) {
                vector = this.hoveredVector || null;
                equipmentOrientation = this.hoveredNumber || null;
            }
            else if (this.inspectedNumber || this.inspectedVector) {
                vector = this.inspectedVector || null;
                equipmentOrientation = this.inspectedNumber || null;
            }
            const indicatorColor = !equipmentOrientation && vector && vector.parent && services_1.Services.Token.has(core_api_1.IkeToken.PHOTOMEASURE_COLOR_CODING)
                ? core_shared_1.FormModelFieldSubForm.getSpanColor(vector.parent)
                : 'white';
            // I hate that we have to do this, but there is no other way to figure out where a capture is coming from to be able to determine if it is markable or not
            this.draw.collection.forEachField((field) => {
                if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field) &&
                    field.getCaptureIds().includes(this.draw.capture.objectId)) {
                    this.draw.isMarkable = true;
                }
            });
            const isIkeAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
            const renderOptions = {
                draw: this.draw,
                units: services_1.Services.UserSettings.units,
                isEditable: this.draw.isMarkable, // TODO check the permission of the user on the collection
                isInteractive: true,
                isThumbnail: false,
                isInsightMarkerLabelsVisible: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_MARKER_LABELS),
                isInsightMarkersVisible: (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_AHOA) || isIkeAnalyst) && this.draw.state.visibleInsightMarkers,
                insightMarkerTypesVisible: services_1.Services.Token.getByPrefix('feature.insight.marker.').map((token) => token.split('.').pop()),
                isInsightMaskVisible: (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_AHOA) || isIkeAnalyst) && this.draw.state.visibleInsightMasks,
                insightMaskTypesVisible: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_AHOA) || isIkeAnalyst
                    ? services_1.Services.Token.getByPrefix('feature.insight.mask.').map((token) => token.split('.').pop())
                    : [],
                isVerticalSeparationEnabled: (0, vertical_separation_field_view_1.canUpdate)(),
                useColorCoding: this.editControl.useColorCoding,
                showOrientation: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_PHOTOMEASURE_COMPASS) || isIkeAnalyst,
                orientationBearing: (0, exports.calculateOrientationBearing)(equipmentOrientation, vector),
                indicatorColor,
                enableRoll: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_PHOTOMEASURE_ROLL) && this.draw.isMarkable,
                scale: core_shared_1.SVGRenderer.scaleUI(this.draw.state, false),
            };
            // Update SVG render options in PhotoMeasureInputEvents so that the Arrange Annotations hotkey has access to it
            this.events.renderOptions = renderOptions;
            // Update the IkeDraw in PhotoMeasureInputEvents because the selected photo may have changed
            this.events.draw = this.draw;
            return (0, mithril_1.m)('div', { className: CSS.center }, [
                (0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(CSS.drawWrapper, { [CSS.hiddenCapture]: hidden }) }, [
                    core_shared_1.SVGRenderer.view(renderOptions),
                    hidden && hidden_image_icon_1.HiddenImageIcon.view(),
                ]),
                // We put the tool bar last as it needs to render over the top of everything
                draw_toolbar_1.DrawToolbar.view(this.draw, this.detail.zoomRenderer.isShown, renderOptions),
            ]);
        }
        if (page_state_1.CurrentState.inspectedCollectionRevision != null) {
            const collectionSummary = store_1.AppStore.CollectionSummary.get(page_state_1.CurrentState.inspectedCollectionRevision);
            if (collectionSummary != null) {
                return (0, mithril_1.m)('div', { className: CSS.empty }, core_shared_1.CaptureProviderHelpers.getCaptureIds(this.editControl.collection).length
                    ? (0, i18n_1.Translate)(i18n_1.T.SELECT_CAPTURE)
                    : (0, i18n_1.Translate)(i18n_1.T.NO_CAPTURES));
            }
        }
        return (0, mithril_1.m)('div', { className: core_shared_1.SVGRenderer.CSS.container });
    }
    parseURL(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const activeRoute = services_1.Services.Route.active;
            if (activeRoute == null || activeRoute.config.name !== this.config.name) {
                return;
            }
            const departmentId = params.d;
            const tagId = params.t;
            const collectionUUID = params.collection;
            const captureId = params.capture;
            if (!services_1.Services.Department.hasDepartment(departmentId)) {
                this.setInvalidURL(true);
                services_1.Services.Log.Logger.warn({ departmentId }, 'Department Id in URL is invalid');
                return;
            }
            services_1.Services.Department.setDepartment(departmentId);
            const tag = yield store_1.AppStore.Tag.fetch(tagId);
            if (tag == null) {
                this.setInvalidURL(true);
                services_1.Services.Log.Logger.warn({ tagId }, 'Tag Id in URL is invalid');
                return;
            }
            services_1.Services.Search.filterState.addTagFilter(tag);
            let collectionSummary;
            if (collectionUUID != null) {
                collectionSummary = yield store_1.AppStore.CollectionSummary.getFetchableByUuid(collectionUUID).refetch();
            }
            else {
                const tagSummary = yield store_1.AppStore.TagSummary.getFetchable(tagId).fetch();
                collectionSummary = yield store_1.AppStore.CollectionSummary.fetch(tagSummary.revisions[0]);
            }
            if (collectionSummary == null) {
                this.setInvalidURL(true);
                services_1.Services.Log.Logger.warn({ collectionUUID }, 'Collection Id in URL is invalid');
                return;
            }
            if (collectionSummary.tags.indexOf(core_api_2.SystemTag.deleted) === -1) {
                page_state_1.CurrentState.setInspectedCollection(collectionSummary.revision, captureId);
            }
            else {
                page_state_1.CurrentState.setInspectedTagId(tagId);
            }
        });
    }
    /**
     * @private
     * @deprecated This property will be set to private. Any outside access should go through new public methods that encapsulate the draw state.
     */
    get draw() {
        const editState = page_state_1.CurrentState.CollectionEdit;
        if (!editState.isEditing ||
            page_state_1.CurrentState.CollectionEdit.collectionRevision !== page_state_1.CurrentState.inspectedCollectionRevision) {
            return null;
        }
        if (page_state_1.CurrentState.inspectedCaptureId == null) {
            return null;
        }
        return editState.getIkeDraw(page_state_1.CurrentState.inspectedCaptureId);
    }
    viewProperties(drawableId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (drawableId == null || this.draw == null) {
                return;
            }
            if (modal_service_1.ModalService.isOpen) {
                return;
            }
            const drawState = this.draw.state;
            const drawable = this.draw.drawState.getDrawable(drawableId);
            const inputModal = new drawable_properties_1.DrawablePropertiesComponent(drawable);
            if (!inputModal.isValid) {
                return drawState.propertiesHide();
            }
            const response = yield inputModal.open();
            if (!response.ok) {
                return drawState.propertiesHide();
            }
            if (core_shared_2.CollectionModelDrawableMarker.isBase(drawable)) {
                this.setBaseOffset(drawable, inputModal.offsetState.value);
            }
            else {
                if (inputModal.state.value == null || inputModal.state.value.toString().trim().length === 0) {
                    this.setMarkerLabel(drawable, null);
                }
                else {
                    this.setMarkerLabel(drawable, inputModal.state.value);
                }
            }
            // Approve the insight flag from the drawable if the user adds a manual label
            if (drawable.isApprovableInsightDrawable()) {
                drawable.approveInsightFlag();
            }
            drawState.propertiesHide();
        });
    }
    setBaseOffset(drawable, value) {
        drawable.offset = value;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, 'tool:base:offset', this.draw.collection.revision);
    }
    setMarkerLabel(drawable, value) {
        value = value != null ? value.trim() : '';
        if (value.length > 0) {
            drawable.label.text = [value];
        }
        else {
            drawable.label.text = [];
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, 'tool:label', this.draw.collection.revision);
    }
    updateInspectedCapture() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (page_state_1.CurrentState.inspectedCollectionRevision == null) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.tagState.map.zoomToCollection(page_state_1.CurrentState.inspectedCollectionRevision);
            const collection = yield store_1.AppStore.Collection.fetch(page_state_1.CurrentState.inspectedCollectionRevision);
            if (collection.revision !== page_state_1.CurrentState.inspectedCollectionRevision) {
                // Inspected collection may change while downloading collection
                return;
            }
            let captureId = page_state_1.CurrentState.inspectedCaptureId;
            if (captureId == null) {
                captureId = services_1.Services.Collection.getFirstCaptureId(collection);
            }
            this.events.trackEvents();
            page_state_1.CurrentState.setInspectedCollection(page_state_1.CurrentState.inspectedCollectionRevision, captureId);
        });
    }
    updateURL() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const departmentId = services_1.Services.Department.current.objectId;
            const tagId = page_state_1.CurrentState.inspectedTagId || services_1.Services.Route.params.get('t');
            if (departmentId == null || tagId == null || page_state_1.CurrentState.inspectedCollectionRevision == null) {
                return;
            }
            const collectionSummary = yield store_1.AppStore.CollectionSummary.fetch(page_state_1.CurrentState.inspectedCollectionRevision);
            const collectionUUID = collectionSummary.uuid;
            const captureId = page_state_1.CurrentState.inspectedCaptureId;
            // Don't update history if current URL only contains departmentId and tagId
            const updateHistory = services_1.Services.Route.params.get('capture') != null;
            services_1.Services.Route.setAllParams({
                d: departmentId,
                t: tagId,
                collection: collectionUUID,
                capture: captureId,
            }, updateHistory);
        });
    }
    setInvalidURL(invalid) {
        this.invalidUrl = invalid;
    }
    setInspectedVector(field) {
        this.inspectedVector = field;
    }
    setInspectedNumber(field) {
        this.inspectedNumber = field;
    }
    setHoveredVector(field) {
        this.hoveredVector = field;
    }
    setHoveredNumber(field) {
        this.hoveredNumber = field;
    }
    onBeforeUnload() {
        this.list.overlay.capture = null;
        page_state_1.CurrentState.inspectedCaptureId = null;
    }
    registerCtrlShiftPressed(eventType, isPressed, modifiers) {
        this.eventContext.on(this.eventContext.Code.AllKeys, () => {
            page_state_1.CurrentState.setIsCtrlShiftPressed(isPressed);
        }, {
            eventType,
            modifiers,
        });
    }
}
exports.PhotoMeasurePage = PhotoMeasurePage;
tslib_1.__decorate([
    mobx_1.observable
], PhotoMeasurePage.prototype, "invalidUrl", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PhotoMeasurePage.prototype, "inspectedVector", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PhotoMeasurePage.prototype, "inspectedNumber", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PhotoMeasurePage.prototype, "hoveredVector", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PhotoMeasurePage.prototype, "hoveredNumber", void 0);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasurePage.prototype, "setBaseOffset", null);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasurePage.prototype, "setMarkerLabel", null);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasurePage.prototype, "setInvalidURL", null);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasurePage.prototype, "setInspectedVector", null);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasurePage.prototype, "setInspectedNumber", null);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasurePage.prototype, "setHoveredVector", null);
tslib_1.__decorate([
    mobx_1.action
], PhotoMeasurePage.prototype, "setHoveredNumber", null);
//# sourceMappingURL=photomeasure.page.js.map